<div class="flex h-[3.75rem] items-center justify-between gap-3 p-3">
  @if (queueItem?.leadingIcon) {
    <svg-icon
      [class]="queueItem.leadingIcon?.color"
      [src]="$safeNavigationMigration(queueItem.leadingIcon?.iconUrl)"
    />
  }

  <div class="grid w-full grid-cols-1 gap-2">
    <!-- Queue Item Title -->
    <span class="truncate text-sm font-semibold text-slate-800">
      {{ queueItem.title }}
    </span>

    <!-- Queue Item Subtitle -->
    @if (queueItem?.subTitle) {
      <span class="truncate text-xs">
        {{ queueItem.subTitle }}
      </span>
    }
  </div>

  <!-- Queue Item action -->
  @if (queueItem?.action) {
    <ag1-link
      variant="secondary"
      [label]="$safeNavigationMigration(queueItem.action?.label)"
      (clickEvent)="onItemClick(queueItem)"
    />
  }

  <!-- Queue Item State Icon excluding loading state -->
  @if (queueItem?.state !== "loading") {
    <svg-icon
      [class]="getStateColor(queueItem.state)"
      [src]="getStateIcon(queueItem.state)"
    />
  }

  <!-- Queue Item Loading State -->
  @if (queueItem?.state === "loading") {
    <ag1-loader classOverrides="!border-4 !w-5 !h-5" />
  }
</div>
